import { style } from '@vanilla-extract/css';

export const container = style({
  flexDirection: 'var(--flex-direction)',
  alignItems: 'center',
  justifyContent: 'start',

  '@media': {
    'only screen and (--mobile)': {
      flexDirection: 'var(--mobile-flex-direction)',
    },
  },
});

export const button = style({
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  alignItems: 'center',
  color: 'var(--button-color) !important',
  backgroundColor: 'var(--button-background-color) !important',
  padding: 'var(--button-padding)',
  borderRadius: '8px',
  lineHeight: 1,
  fontSize: 'var(--button-font-size)',
  ':hover': {
    color: 'var(--hover-button-color) !important',
    backgroundColor: 'var(--hover-button-background-color) !important',
  },
});
